import React from 'react'
import * as MabnaButton from '../common/Button/Button'
import { browserHistory } from 'react-router'

const styles = {
  headingWrapper: { flex: 1, marginBottom: 10 },
  wrapperTitle: { margin: 0, padding: 10 },
  mainWrapper: { marginBottom: 20, marginTop: 20 },
}

const RestPassSuccess = () => (
  <div id="signup-success">
    <div className="text-center bg-darkblue fg-white" style={styles.headingWrapper}>
      <h4 style={styles.wrapperTitle}>بازیابی گذرواژه</h4>
    </div>

    <div style={styles.mainWrapper}>
      <h4>گذرواژه جدید ثبت شد</h4>

      <MabnaButton.Primary
        onClick={() => browserHistory.push('/')}
      >
        ورود به سامانه
      </MabnaButton.Primary>
    </div>
  </div>
)

export default RestPassSuccess



// WEBPACK FOOTER //
// ./src/components/authentication/RestPassSuccess.js